import { BlogPageView } from "../VIEW/BlogPageView";

function BlogPage() {
  return <BlogPageView />;
}

export default BlogPage;
